
export const mapperColumnsDetails = [
    {
        "field": "fileName",
        "headerName": "File Name",
        "flex":1,
        "sortable": false,
        "minWidth": 300
    },
    {
        "field": "entityName",
        "headerName": "Type",
        "flex":1,
        "sortable": false,
        "minWidth" : 140
    },
    {
        "field": "size",
        "headerName": "Size",
        "flex":1,
        "sortable": false,
        "minWidth" : 100
    },
    {
        "field": "recordCount",
        "headerName": "Record Count",
        "flex":1,
        "sortable": false,
        "minWidth" : 100
    },
    {
        "field": "lastmodified",
        "headerName": "Last Modified",
        "flex":1,
        "sortable": false,
        "minWidth" : 180
    },
  ]